import { render } from "./CoachItem.vue?vue&type=template&id=7763bac8&scoped=true"
import script from "./CoachItem.vue?vue&type=script&lang=js"
export * from "./CoachItem.vue?vue&type=script&lang=js"

import "./CoachItem.vue?vue&type=style&index=0&id=7763bac8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7763bac8"

export default script